import { createSelector } from 'reselect';
import { addMonths, startOfDay, format } from 'date-fns';
import { SERVER_DATE_FORMAT } from 'constants/logic';
import { adjustDateForTimezone } from 'helpers/intl-fns';
import { selectActiveVenueId, selectVenueTimezone, selectVenueClasses } from 'selectors/general';
import { classtivitySchedules } from 'store/saga/entities/bound';

const classtivitySchedulerSelector = state => state.classtivityScheduler;

export const selectNewScheduleInstances = createSelector(
  classtivitySchedulerSelector,
  cScheduler => cScheduler.newScheduleInstances || []
);

export const selectNewClassId = createSelector(classtivitySchedulerSelector, cScheduler => cScheduler.newClassId);

export const selectNewScheduleInstancesLength = createSelector(
  selectNewScheduleInstances,
  scheduleInstances => scheduleInstances?.length || 0
);

const selectClasstivitySchedulesEntity = createSelector(
  state => state,
  selectActiveVenueId,
  selectVenueTimezone,
  (state, venueId, timezone) => {
    const now = new Date();
    const startDate = startOfDay(adjustDateForTimezone(now, timezone));
    const endDate = addMonths(startDate, 6);
    return classtivitySchedules.select(
      state,
      classtivitySchedules.defaultKey(
        null,
        venueId,
        format(startDate, SERVER_DATE_FORMAT),
        format(endDate, SERVER_DATE_FORMAT)
      )
    );
  }
);

export const selectClasstivitySchedules = createSelector(
  selectClasstivitySchedulesEntity,
  ({ data, error, loaded, loading }) => ({
    data: loaded ? data : [],
    error,
    isLoaded: loaded,
    isLoading: loading,
  })
);

export const selectAllSchedules = createSelector(
  selectNewScheduleInstances,
  selectClasstivitySchedules,
  selectVenueClasses,
  (newScheduleInstances, { data: existingScheduleInstances }, classes) => {
    const decoratedNewScheduleInstances = newScheduleInstances.map(
      ({ classId: classtivityClassId, ...restScheduleInstance }) => ({
        classtivityClassId,
        ...restScheduleInstance,
        className: classes?.find(({ classId }) => classId === classtivityClassId)?.className,
        _isNew: true,
      })
    );

    return [...decoratedNewScheduleInstances, ...existingScheduleInstances];
  }
);
